import axios from 'axios'
import {to} from './utils'

export default {
  async checkin (qrCode) {
    return to(axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/checkin/${qrCode}`))
  }
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/endpoints/checkin.js
// module id = null
// module chunks = 